<template>
	<component :is="(to ? (typeof to==='string' ? 'a':'router-link') : 'div')"
						 :href="typeof to==='string' ? to : null"
						 :to="typeof to==='string' ? null : to"
						 :tabindex="disabled ? null : 0"
						 class="btn download-btn"
						 :class="classes+ ' '+(typeof to)+(disabled?' disabled':'')"
						 :target="typeof to!=='object' ? target : null"
						 :rel="rel"
						 :disabled="disabled"
						 @keypress.enter="click"
						 :aria-label="arialabel"
						 @click="click">
<!--		:to="typeof to==='object' ? to : null"-->
		<i v-if="icon" :class="'fa fa-'+icon"></i>
		<div class="txt d-none d-sm-block">
			<small v-if="text[0]">{{text[0]}}<br></small>
			<small v-else style="margin-top: 5px; display:block"></small>
			{{text[1]}}
		</div>
		<div class="txt d-block d-sm-none">
			<small v-if="xs[0]">{{xs[0]}}<br></small>
			<small v-else style="margin-top: 5px; display:block"></small>
			{{xs[1]}}
		</div>
	</component>
</template>
<script>
	export default{
		name:'download-btn',
		props:{
			to:{
				type:[Object, String],
				default:null
			},
			icon:{
				type: String,
				default:null
				// 'shopping-basket'
			},
			classes:{default:null},
			target:{default:'_self'},
			text:{ type:Array, default:() =>['Passer','Commande']},
			textxs:{ default:null },
			rel:{default:'noopener'},
			disabled:{default:false},
		},
		computed:{
			xs(){
				return this.textxs ? this.textxs : this.text;
			},
			arialabel(){
				let string = this.text.join(" ").toLowerCase();
				return string.charAt(0).toUpperCase() + string.slice(1);
			}
		},
		methods:{
			click(event){
				this.gtag('click', 'btn', this.arialabel);

				if(this.disabled) return;
				// console.log("click", this.to, typeof this.to);
				if(this.to && typeof this.to==='object'){
					// console.log(this.to);
					this.$router.push(this.to);
				// }else if(typeof to==='string'){
				// 	window.location = to;
				}else{
					this.$emit('click', event);
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../../src/assets/less/variables.scss';
	@import '~bootstrap/scss/bootstrap-grid.scss';

	.download-btn{
		/*&:not(.dis)cursor: pointer;*/
		&.disabled,
		&:disabled {
			cursor: initial;
		}
		vertical-align: top;
		/*text-align: left;*/
		text-align: center;
		/*border: 1px solid #fff;*/
		color: #fff!important;
		position: relative;
		overflow: hidden;
		display: flex;
		align-items: center;
		/*float: left;*/
		display: inline-flex;
		/*padding: 10px 20px;*/
		padding: 1.5vh 1.5vw;
		border-radius: 5px;
		border: none;
		-webkit-transition: background-color 0.2s ease-in-out;
		-moz-transition: background-color 0.2s ease-in-out;
		-ms-transition: background-color 0.2s ease-in-out;
		-o-transition: background-color 0.2s ease-in-out;
		transition: background-color 0.2s ease-in-out;
		margin: 0.5vh 1vw;
		outline: none;
		small{
			display: block;
		}
		i{
			font-size: 28px;
			line-height: 28px;
			-webkit-transition: color 0.2s ease-in-out;
			-moz-transition: color 0.2s ease-in-out;
			-ms-transition: color 0.2s ease-in-out;
			-o-transition: color 0.2s ease-in-out;
			transition: color 0.2s ease-in-out;
			@include smartphones(){
				font-size: initial;
				line-height: initial;
			}
      width: initial!important;
		}
		i + .txt{
			margin-left: 1.5vw;
			/*margin-bottom: 5px;*/
		}
		.txt{
			-webkit-transition: color 0.2s ease-in-out;
			-moz-transition: color 0.2s ease-in-out;
			-ms-transition: color 0.2s ease-in-out;
			-o-transition: color 0.2s ease-in-out;
			transition: color 0.2s ease-in-out;
			font-size: 18px;
			padding: 0;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			line-height: 20px;

			font-family: 'Montserrat', sans-serif;
			font-weight: 600;
			small{
				font-size: 12px;
				line-height: 12px;
				font-family: 'Open Sans', sans-serif;
				font-weight: 400;
			}
		}
		@include smartphones(){
			padding: 1.5vh 20px;
			/*padding: 6px 12px;*/
			&.noresp{
				i{
					display: none;
				}
				.txt{
					margin: 0!important;
					text-align: center;
					font-size: 12px;
					line-height: 12px;
				}
			}
			&:not(.noresp){
				.txt{
					display: none!important;
				}
			}
		}
		a:hover,
		a:focus{
			background: #fff;
		}
		a:hover p,
		a:focus p,
		a:hover span,
		a:focus span,
		&.primary span,
		.hover-active span{
			background: linear-gradient(to bottom, #281483 15%, #8f6ed5 70%, #d782d9 94%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
		&.primary,
		&.hover-active{
			p,
			i{
				color: $tertiary-color;
			}
		}
		&.primary{
			border-color: $tertiary-color;
		}
		&.primary,
		&.hover-active{
			background-color: $tertiary-color;
			p,
			i{
				color: white;
			}
		}
		&:hover,
		&:focus{
			&.primary{
				background-color: transparentize($tertiary-color, .2);
			}
			p,
			i{
				color: white;
			}
		}
	}
</style>
